const axios = require("axios");
const util = require("@/util");
import { Message } from 'element-ui';
import store from "@/store";
const dialogutil = require("@/dialogutil");

// 登录用户的会话有效时长
const loginUserSessionSeconds = 60 * 60 * 24 * 7;

export default {
    /**
    * 取得当前登录用户
    */
    getLoginUser() {
        return util.getFromLocalStorage("loginUser");
    },

    /**
    * 更新当前登录用户的数据
    */
    updateLoginUser(loginUser) {
        util.storeToLocalStorage(
            "loginUser",
            loginUser,
            loginUserSessionSeconds,
        );
    },

    /**
     * 更新当前登录用户的会话有效时长
     */
    updateLoginUserSessionValidDuration() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            this.updateLoginUser(loginUser);
        }
    },

    /**
    * 取得当前登录用户的token
    */
    getLoginUserToken() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            return loginUser.token;
        } else {
            return "";
        }
    },

    /**
    * 取得当前登录用户的角色
    */
    getLoginUserRole() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            return loginUser.role;
        } else {
            return "";
        }
    },

    isCustomerService() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            return loginUser.role == "客服";
        }
        return true;
    },

    // 操作需要被审核
    isAuditedWithOperation() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            return loginUser.isAuditedWithOperation
        }
        return false;
    },

    isAdministrator() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            return loginUser.role == "管理员";
        }
        return false;
    },

    /**
     * 判断当前登录用户是否拥有指定权限集合当中的任一权限
     * @param {[]string} privileges
     */
    hasAnyPrivilege(privileges) {
        let loginUser = this.getLoginUser();
        if (!loginUser) {
            return false;
        }

        if (!loginUser.privileges) {
            return false;
        }

        for (let pri1 of privileges) {
            for (let pri2 of loginUser.privileges) {
                if (pri2 == pri1) {
                    return true;
                }
            }
        }

        return false;
    },

    /**
     * 查询我的账号信息
     */
    async queryMyProfile() {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/queryMyProfile`,
                {},
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            this.$message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        // 将查询到的信息给保存下来
        {
            let loginUser = this.getLoginUser();

            loginUser.username = resData.data.username;
            loginUser.role = resData.data.role;
            loginUser.privileges = resData.data.privileges;
            loginUser.address = resData.data.address;
            loginUser.addressType = resData.data.addressType;
            loginUser.isReceiveCorpNotifications = resData.data.isReceiveCorpNotifications;
            loginUser.isMustSetAddress = resData.data.isMustSetAddress;
            loginUser.isAuditedWithOperation = resData.data.isAuditedWithOperation;

            this.updateLoginUser(loginUser);
        }

        if (resData.data.isMustSetAddress) {
            dialogutil.open("SettingDialog")
        }
    },

    /**
    * 取得当前项目的名称
    */
    getProjectName() {
        return store.projectInfo.name;
    },

    /**
     * 当前是否是生产环境
     */
    isProdEnv() {
        return store.projectInfo.env == "prod";
    },

    /**
     * 当前环境
     */
    env() {
        return store.projectInfo.env;
    },

    /**
     * 后端当前是否跑在云原生环境中
     */
    isCloudNative() {
        return store.projectInfo.isCloudNative;
    },

    /**
     * 查询渠道集合
     * 
     * @returns 
     */
    async loadAvailableChannels() {
        let resData = (
            await axios.get(
                `${util.getBackendApiBase()}/v1/admin/getChannelList`,
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableChannels = [];

        for (let e of resData.data.channels) {
            availableChannels.push({
                id: e.id,
                name: e.name,
            });
        }

        return availableChannels;
    },

    /**
     * 查询来源渠道集合
     * 
     * @returns 
     */
    async loadAvailableSources() {
        let resData = (
            await axios.get(
                `${util.getBackendApiBase()}/v1/admin/getSourceList`,
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableSources = [];

        for (let source of resData.data.sources) {
            availableSources.push(source);
        }

        return availableSources;
    },

    /**
     * 查询分区集合
     * 
     * @returns 
     */
    async loadAvailableZones() {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/manageZones`,
                {
                    action: "list",
                },
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableZones = [];

        for (let e of resData.data.list.zones) {
            availableZones.push({
                id: e.id,
                name: e.name,
            });
        }

        return availableZones;
    },

    /**
     * 查询语言集合
     */
    async loadAvailableLanguages() {
        var resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/getLanguageList`,
                {},
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableLanguages = [];

        if (resData.data.languageList) {
            for (let l of resData.data.languageList) {
                availableLanguages.push(l);
            }
        }

        return availableLanguages;
    },

    /**
    * 查询角色集合
    */
    async loadRoles() {
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/account/manageRoles`,
            {
              action: "list",
            },
            {
              headers: {
                token: this.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
  
        let listInResponse = resData.data.list.roles || [];
    
        let roles = [];

        for (let e of listInResponse) {
            roles.push({
              name: e.name,
              privileges: e.privileges.sort(),
              isBuiltin: e.isBuiltin,
          })
        }
        
        return roles;
    },

    /**
    * 查询可用账号权限集合
    */
    async loadPrivileges() {
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/account/queryAvailablePrivileges`,
            {},
            {
              headers: {
                token: this.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
  
        if (!resData.data.privileges) {
            return [];
        }

        return resData.data.privileges.sort();
    },

    /**
    * 查询附件集合
    */
    async loadAttachments(isShowPayItem) {
        let entries = {}
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/getAppendixList`,
                {
                    isShowPayItem: isShowPayItem,
                },
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        for (let category of resData.data.categories) {
            for (let e of category.entries) {
                entries[e.id] = e.name
            }
        }

        return entries
    },

    /**
    * 查询批注
    * 
    * @returns 
    */
    async queryMicrofilm(key) {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/queryMicrofilm`,
                {
                    key: key
                },
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return "";
        }

        if (resData.data.value) {
            return resData.data.value;
        }

        return ""
    },
    /**
   * 查询支付点集合
   * 
   * @returns 
   */
    async loadPayPoint() {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/queryPayPoint`,
                {},
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let list = [];

        for (let e of resData.data.list) {
            list.push({
                id: e.value,
                name: e.label,
            });
        }

        return list;
    },

    /**
   * 查询用户
   */
    async loadAccounts() {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/getAccountList`,
                {
                },
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;

        let listInResponse = resData.data.list || [];
        return listInResponse
    },

    /**
   * 查询企业事件
   */
    async loadCorpEvents() {
        let resData = (
            await axios.post(
                `${util.getBackendApiBase()}/v1/admin/corpflow/queryCorpEvent`,
                {
                },
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;

        let listInResponse = resData.data.events || [];
        return listInResponse
    },
}